import { apiRequest } from './apiRequest';
import { CONST } from '../constant';

/**
 * check duplication file for user.
 * @returns {Promise}
 */
const hasDuplicateFile = (cid, md5, size) => {
  return new Promise((resolve, reject) => {
    apiRequest('/api/file/dup/' + cid + '/' + md5 + '/' + size, CONST.api_method.get)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

const getStorageUsage = cid => {
  return new Promise((resolve, reject) => {
    apiRequest(`/api/file/usage/${cid}`, CONST.api_method.get)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

const getToken = (fid, randKey) => {
  return new Promise((resolve, reject) => {
    apiRequest(`/api/file/token/${randKey}/${fid}/`, CONST.api_method.get)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

const checkToken = (fid, randKey, token) => {
  return new Promise((resolve, reject) => {
    apiRequest(`/movie/${fid}.l.check?token=${token}`, CONST.api_method.get, {}, false, { 'X-MOVIE-RAND': randKey })
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

export { hasDuplicateFile, getStorageUsage, getToken, checkToken };
